import React, { useEffect, useState } from "react";
import TablePagination from "../Assets/TablePagination";
import TableHeader from "../Assets/TableHeader";
import TableBody from "../Assets/TableBody";
import { Career } from "../Types/Types";
import LoadingCircle from "../Assets/LoadingCirlce";

interface AdminCareerTableProps {
    careers: Career[];
    loading: boolean;
    error: string | null;
    sortBy: string;
    sortOrder: string;
    currentPage: number;
    totalCount: number;
    onSortChange: (sortBy: string, sortOrder: string) => void;
    onPageChange: (page: number) => void;
    onRowsPerPageChange: (rowsPerPage: number) => void;
    onDelete: (id: string) => void;
    onEdit: (career: Career) => void;
    selectedCareerId: string | null;
    lang: string
    success: string | null;
    setSuccess: (message: string | null) => void;  // <-- add this line
}

const AdminCareerTable: React.FC<AdminCareerTableProps> = ({
    careers,
    loading,
    error,
    sortBy,
    sortOrder,
    currentPage,
    totalCount,
    onSortChange,
    onPageChange,
    onRowsPerPageChange,
    onDelete,
    onEdit,
    lang,
    success,
    setSuccess
}) => {
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [showSuccess, setShowSuccess] = useState(false);


    useEffect(() => {
        if (success) {
            setShowSuccess(true);
            const timer = setTimeout(() => {
                setShowSuccess(false);
                setSuccess(null); // clear success after 3 sec
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [success, setSuccess]);


    const handleSort = (column: string) => {
        let order = "asc";
        if (sortBy === column && sortOrder === "asc") {
            order = "desc";
        }
        onSortChange(column, order);
    };

    const handlePageChange = (newPage: number) => {
        if (newPage > 0 && newPage <= Math.ceil(totalCount / rowsPerPage)) {
            onPageChange(newPage);
        }
    };

    const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        onRowsPerPageChange(newRowsPerPage);
    };

    if (loading) {
        return <LoadingCircle />
    }

    if (error) {
        return <div className="text-center py-4 text-red-500">{error}</div>;
    }

    // Show all careers for admin management/testing
    const filteredCareers = careers;


    return (
        <div className="overflow-x-auto bg-white shadow-md rounded-lg">
            {showSuccess && (
                <div className="absolute left-1/2 bottom-4 transform -translate-x-1/2 bg-green-600 text-white px-6 py-2 rounded-full shadow-lg text-lg font-semibold select-none">
                    {success}
                </div>
            )}

            <table className="min-w-full table-auto">
                <TableHeader
                    data={filteredCareers}
                    handleSort={handleSort}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    showActiveColumns={true}
                />

                <TableBody
                    data={filteredCareers}
                    onDelete={(id: string) => onDelete(id)}
                    onEdit={onEdit}
                    lang={lang}
                    editable={false}
                />
            </table>

            <TablePagination
                currentPage={currentPage}
                totalCount={totalCount}
                rowsPerPage={rowsPerPage}
                onPageChange={handlePageChange}
                onRowsPerPageChange={handleRowsPerPageChange}
            />
        </div>
    );
};

export default AdminCareerTable;
